export default __webpack_public_path__ + "static/media/kada1.158ffb8f.jpg";